import { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
    setFieldFactory,
    setShowFieldErrorFactory,
} from '../../actions/sign-up/SignUpActions';
import SignUpContext from '../../contexts/sign-up/SignUpContext';
import { validationFn } from '../../typings';

/**
 * Custom hook that extracts a parameter from the URL and dispatches a SIGN_UP_UPDATE_FIELD action
 *
 * @param paramName The name of the URL parameter to extract
 * @param fieldName The name of the field to update in the sign-up context
 * @param validateFn The validation function to use for the field
 */
export const usePrefillFromSearchParams = (
    paramName: string,
    fieldName: string,
    validateFn: validationFn
) => {
    const { dispatch } = useContext(SignUpContext);
    const [searchParams] = useSearchParams();
    const setField = setFieldFactory(dispatch, fieldName);
    const setShowFieldError = setShowFieldErrorFactory(dispatch, fieldName);

    useEffect(() => {
        const value = searchParams.get(paramName);

        if (value) {
            const err = validateFn(value);
            const isValid = err === null;
            setField(value, isValid, err);
            if (!isValid) {
                setShowFieldError(true);
            }
        }
    }, []);
};

export default usePrefillFromSearchParams;
